export const WRITE = 'WRITE';
export const WRITE_CHMOD = 'WRITE|CHMOD';
export const CREATE = 'CREATE';
export const REMOVE = 'REMOVE';
export const RENAME = 'RENAME';
export const REMOVE_RENAME = 'REMOVE|RENAME';
